import { GeographyService } from "@/core/services";

// Clave de persistencia del nivel de navegación (DEF-ADM-009).
// Valores posibles almacenados:
//   { type: 'admin' }                    -> Nivel 1: Administración (global)
//   { type: 'city', city: {...} }        -> Nivel 2: operación dentro de una ciudad
// Ausente -> el operador todavía no eligió nivel: se le muestra la pantalla de cards.
const STORAGE_KEY = "navLevel";

function loadStoredLevel() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

const state = {
  cities: [],
  citiesLoaded: false,
  level: loadStoredLevel(),
};

const getters = {
  getCities: (state) => state.cities,
  areCitiesLoaded: (state) => state.citiesLoaded,
  // true cuando el operador ya eligió Administración o una ciudad
  isLevelChosen: (state) => state.level !== null,
  isAdminLevel: (state) => state.level != null && state.level.type === "admin",
  isCityLevel: (state) => state.level != null && state.level.type === "city",
  getCurrentCity: (state) =>
    state.level != null && state.level.type === "city" ? state.level.city : null,
  // Etiqueta que muestra el header: "Lima" / "Cusco" / "TravelCab"
  getLevelLabel: (state) =>
    state.level != null && state.level.type === "city"
      ? state.level.city.name
      : "TravelCab",
};

const actions = {
  loadCities({ commit }) {
    return new Promise((resolve, reject) => {
      GeographyService.listCities()
        .then((resp) => {
          const all = resp.payload || [];
          commit("setCities", all.filter((c) => c.is_active));
          resolve(all);
        })
        .catch((ex) => {
          console.error(ex);
          reject(ex);
        });
    });
  },
  selectCity({ commit }, city) {
    commit("setLevel", { type: "city", city });
  },
  selectAdminLevel({ commit }) {
    commit("setLevel", { type: "admin" });
  },
  clearLevel({ commit }) {
    commit("setLevel", null);
  },
};

const mutations = {
  setCities(state, value) {
    state.cities = value;
    state.citiesLoaded = true;
  },
  setLevel(state, value) {
    value
      ? localStorage.setItem(STORAGE_KEY, JSON.stringify(value))
      : localStorage.removeItem(STORAGE_KEY);
    state.level = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
